import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'
import React from 'react'

interface LoaderProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export function LoadingSpinner({ className, ...props }: LoaderProps) {
  return (
    <div
      {...props}
      className={cn('flex items-center justify-center text-primary', className)}
    >
      <Loader2 className="animate-spin size-7" />
    </div>
  )
}
